import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

export const getCountriesCodeSource = ({
  countriesCode,
  defaultCountryValue,
}: {
  countriesCode: any
  defaultCountryValue: string
}) => {
  const data = Object.keys(countriesCode).map((one) => {
    if (defaultCountryValue && countriesCode[one].includes(defaultCountryValue)) {
      return {
        key: one,
        label: `+${one}-${defaultCountryValue}`,
        code: defaultCountryValue,
      }
    } else {
      return {
        key: one,
        label: `+${one}-${countriesCode[one][0]}`,
        code: countriesCode[one],
      }
    }
  })
  return new Crud({
    fetcher: new Static(data),
    keyField: 'key',
    defaultPaging: {
      page: 0,
      pageSize: data.length,
    },
  })
}
